import styled from 'styled-components'



export const StyledSpinnerWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;  // Full viewport height to center vertically
`;
